import { CmsTextProps } from '~/types/Cms';

const CmsText = ({ data }: CmsTextProps) => {
  const alignment = data.align || 'inherit';
  return (
    <div className="cms-text" style={{ textAlign: alignment }} dangerouslySetInnerHTML={{ __html: data.content }} />
  );
};

export default CmsText;
